module.exports = __webpack_public_path__ + "img/header-engagementRingsCharacter@2x.54226ff.webp";